import {
    CANDIDATE_PRO_UPDATE_REQUEST,
    CANDIDATE_PRO_UPDATE_SUCCESS,
    CANDIDATE_PRO_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH;

export const CandidateProAction = (data, navigate) => {
    return function (dispatch) {
        dispatch({
            type: CANDIDATE_PRO_UPDATE_REQUEST,
            payload: true,
        });

        let OPTION = {
            url: `${baseUrl}/ebench/update_Candidate_v2`,
            method: "PUT",
            data: data,
            headers: {
                "content-type": "application/json",
            },
        };

        // ✅ Return the axios promise so caller can await it
        return axios(OPTION)
            .then((res) => {
                dispatch(updateDashboardContentPre(res.data, navigate));
                return res.data; // resolve with response data
            })
            .catch((error) => {
                dispatch({
                    type: CANDIDATE_PRO_UPDATE_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });
                toast.error(error?.response?.data?.status?.message || "Something went wrong", { toastId: 'candidatepro' });
                // rethrow so caller's catch works
                throw error;
            });
    };
};

export const updateDashboardContentPre = (data, navigate) => {
    return {
        type: CANDIDATE_PRO_UPDATE_SUCCESS,
        result: data,
        payload: false,
        msg: "SUCCESS",
    };
};
